export default __webpack_public_path__ + "static/media/Jong_crop_resize.a5d51eca.jpg";